import { Injectable } from '@angular/core';
import {
  NotificationReminder, NotificationSettings, NotificationToggle, UpdateNotificationSettings,
} from '../../domain/models/notification-settings.model';
import {
  NotificationReminderDto, NotificationSettingsDto, NotificationToggleDto, UpdateNotificationSettingsRequestDto,
} from '../dtos/notification-settings.dto';

@Injectable()
export class NotificationSettingsMapper {
  public toNotificationSettings(dto: NotificationSettingsDto): NotificationSettings {
    return {
      push: dto.Push.map((toggle) => this.toToggle(toggle)),
      email: dto.Email.map((toggle) => this.toToggle(toggle)),
      reminders: dto.Reminders.map((reminder) => this.toReminder(reminder)),
      internalAlerts: dto.InternalAlerts.map((toggle) => this.toToggle(toggle)),
      updatedAtUtc: dto.UpdatedAtUtc,
    };
  }

  public toUpdateRequest(model: UpdateNotificationSettings): UpdateNotificationSettingsRequestDto {
    return {
      Push: model.push.map((toggle) => this.toToggleDto(toggle)),
      Email: model.email.map((toggle) => this.toToggleDto(toggle)),
      Reminders: model.reminders.map((reminder) => this.toReminderDto(reminder)),
      InternalAlerts: model.internalAlerts.map((toggle) => this.toToggleDto(toggle)),
    };
  }

  private toToggle(dto: NotificationToggleDto): NotificationToggle {
    return { key: dto.Key, enabled: dto.Enabled, timing: dto.Timing ?? null };
  }

  private toReminder(dto: NotificationReminderDto): NotificationReminder {
    return {
      key: dto.Key,
      enabled: dto.Enabled,
      firstOffset: dto.FirstOffset ?? null,
      secondOffset: dto.SecondOffset ?? null,
      channels: dto.Channels ?? [],
    };
  }

  private toToggleDto(model: NotificationToggle): NotificationToggleDto {
    return { Key: model.key, Enabled: model.enabled, Timing: model.timing };
  }

  private toReminderDto(model: NotificationReminder): NotificationReminderDto {
    return {
      Key: model.key,
      Enabled: model.enabled,
      FirstOffset: model.firstOffset,
      SecondOffset: model.secondOffset,
      Channels: model.channels,
    };
  }
}
